module.exports = __webpack_public_path__ + "img/ring_g_l_1_null@2x.f68a49af.png";